import { Toggle, Typography } from "@trustpilot/businessapp-patternlibrary";
import { Text } from "ilenia";
import React from "react";

import { StyledTertiaryActionArea, StyledToggleText } from "./styled";

type AlwaysShowAtLoginToggleTypes = {
  showOnLogin: boolean;
  setShowOnLogin: (boolean: boolean) => void;
};

const AlwaysShowAtLoginToggle: React.FC<AlwaysShowAtLoginToggleTypes> = ({ showOnLogin, setShowOnLogin }) => (
  <StyledTertiaryActionArea>
    <Toggle
      checked={showOnLogin}
      onChange={() => {
        setShowOnLogin(!showOnLogin);
      }}
    />
    <StyledToggleText
      data-testid="toggle-always-show"
      onClick={() => {
        setShowOnLogin(!showOnLogin);
      }}
    >
      <Typography variant="body-m">
        <Text id="account-selector.show_on_log_on" />
      </Typography>
    </StyledToggleText>
  </StyledTertiaryActionArea>
);

export default AlwaysShowAtLoginToggle;
